import styled from 'styled-components'

const ModalListWrapper = styled.div`
  bottom: 85px;
  left: 0;
  padding: 0 20px 20px;
  position: absolute;
  top: 68px;
  width: 100%;
`

export default ModalListWrapper
